import * as S from '@effect/schema/Schema';

import {SqliteBoolean, id, table, String1000} from '@evolu/common';

const SomeJson = S.Struct({foo: S.String, bar: S.Boolean});

type SomeJson = S.Schema.Type<typeof SomeJson>;

const ItemId = id('Item');

type ItemId = S.Schema.Type<typeof ItemId>;

export const ItemTable = table({
  id: ItemId,
  name: String1000,
  title: String1000,
  isCompleted: SqliteBoolean,
  item: SomeJson,
  isMediaNew: SqliteBoolean,
  isContact: SqliteBoolean,
  folderId: String1000,
  isDevice: SqliteBoolean,
  isFolder: SqliteBoolean,
  folderType: String1000,
  userDoc: SqliteBoolean,
  chatId: String1000,
  orderId: String1000,
  mediaId: String1000,
  auctionId: String1000,
  lastUpdated: String1000,
  isEditorProject: SqliteBoolean,
  isEditorLayer: SqliteBoolean,
  isDatabase: SqliteBoolean,
  isAuction: SqliteBoolean,
  mnemonic: String1000,
});

export type ItemTable = S.Schema.Type<typeof ItemTable>;
